import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSettings = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M14.25 12.8972C14.25 14.1399 13.2426 15.1472 12 15.1472C10.7574 15.1472 9.75 14.1399 9.75 12.8972C9.75 11.6546 10.7574 10.6472 12 10.6472C13.2426 10.6472 14.25 11.6546 14.25 12.8972Z",
		stroke: "currentColor",
		strokeWidth: 1.2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M14.9849 5.69096L13.91 3.96462C13.0294 2.55036 10.9706 2.55036 10.09 3.96463L9.01507 5.69096L7.03427 5.23035C5.41154 4.85301 3.95579 6.30876 4.33314 7.93149L4.79374 9.91229L3.06741 10.9872C1.65314 11.8679 1.65314 13.9266 3.06741 14.8072L4.79374 15.8821L4.33314 17.8629C3.95579 19.4857 5.41154 20.9414 7.03427 20.5641L9.01507 20.1035L10.09 21.8298C10.9706 23.2441 13.0294 23.2441 13.91 21.8298L14.9849 20.1035L16.9657 20.5641C18.5885 20.9414 20.0442 19.4857 19.6669 17.8629L19.2063 15.8821L20.9326 14.8072C22.3469 13.9266 22.3469 11.8679 20.9326 10.9872L19.2063 9.91229L19.6669 7.93149C20.0442 6.30875 18.5885 4.85301 16.9657 5.23035L14.9849 5.69096ZM18.192 6.70523L14.1782 7.63857L12 4.14042L9.8218 7.63857L5.80801 6.70523L6.74136 10.719L3.24321 12.8972L6.74136 15.0754L5.80801 19.0892L9.8218 18.1559L12 21.654L14.1782 18.1559L18.192 19.0892L17.2586 15.0754L20.7568 12.8972L17.2586 10.719L18.192 6.70523Z",
		fill: "currentColor"
	})]
});
export default SvgSettings;
